
























/**
 * 入力訴求
 */
import Vue from "vue"
import PSkillTagBanner from "./PSkillTagBanner.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
    ConversionButton,
    PSkillTagBanner,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
    isSkillTag() {
      // MEMO 暫定的な対応
      // スキルタグ以外の項目もイラスト付きのコンポーネントにできそうなら見直す。
      return this.buttonText === "スキルタグを追加"
    },
  },
  methods: {
    handleClick() {
      this.$emit("click")
    },
  },
})
